<template lang="pug">
main.app-main.forbidden-page
    div.message
        div.anim-text-flow 404 Page not found
        router-link.go-back.btn.btn--medium.btn--round.btn-simple(:to="{ name: 'dashboard', params: { account_id: this.$route.params.account_id } }") Go back to Dashboard
</template>

<script>
export default {
    name: 'Forbidden',
}
</script>
<style lang="scss" scoped>
.forbidden-page {
    display: grid;
    place-items: center;

    .message {
        display: grid;
        place-items: center;
        margin-top: -150px;
    }

    .go-back {
        font-size: 1.2rem;
        font-weight: regular;
        text-align: center;
        text-transform: capitalize;
        &:hover {
            border-color: #e296a7;
            color: #a82a5e;
        }
    }

    .anim-text-flow {
        font-size: 60px;
        font-weight: 800;
        letter-spacing: 2px;
        text-align: center;
        color: #a82a5e;
        background-image: -webkit-linear-gradient(150deg, #a82a5e, #fc352d);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-animation: hue 10s infinite linear;
    }
}
@-webkit-keyframes hue {
    from {
        -webkit-filter: hue-rotate(0deg);
    }
    to {
        -webkit-filter: hue-rotate(-360deg);
    }
}
</style>
